module.exports = __webpack_public_path__ + "img/login-germanavila.92e60cfb.svg";